const scrollToTop = () => {
  const nativeSmoothScrollTo = () => {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: 0
    });
  };

  // polyfilled smooth scrolling for IE, Edge & Safari
  const smoothScrollTo = () => {
    const element = document.scrollingElement || document.documentElement;
    element.scrollTop = 0;
  };

  // detect support for the behavior property in ScrollOptions
  const supportsNativeSmoothScroll =
    'scrollBehavior' in document.documentElement.style;

  if (supportsNativeSmoothScroll) {
    nativeSmoothScrollTo();
  } else {
    smoothScrollTo();
  }
};

window.scrollToTop = scrollToTop;
